import { render, staticRenderFns } from "./RelatedContentList.vue?vue&type=template&id=089c0e50&scoped=true"
import script from "./RelatedContentList.vue?vue&type=script&lang=js"
export * from "./RelatedContentList.vue?vue&type=script&lang=js"
import style0 from "./RelatedContentList.vue?vue&type=style&index=0&id=089c0e50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089c0e50",
  null
  
)

export default component.exports